import { Theme } from "@mui/material";

export const legalbirdHitsStyles = {
  carouselContainer: {
    width: "100%",
    padding: "0 4.5rem",
    position: "relative",
  },
  carouselArrow: {
    position: "absolute",
    top: "40vh"
  },
  carouselSlide: {
    flexBasis: "calc(100% / 9)",
    padding: "1rem",
  },
  columnLabel: {
    textAlign: "center",
    fontSize: ".875rem",
    fontWeight: 700,
    height: "3rem",
  },
  caseCount: {
    textAlign: "center",
    fontSize: ".75rem",
  },
  leftArrow: {
    position: "fixed",
    top: "40vh",
    left: 80,
  },
  rightArrow: {
    position: "fixed",
    top: "40vh",
    right: 90,
  },
  arrowColors: (theme: Theme) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    opacity: 0.5,
  }),
};

export const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1651 },
    items: 9,
    slidesToSlide: 3,
  },
  shittyMonitor: {
    breakpoint: { max: 1650, min: 1251 },
    items: 6,
    slidesToSlide: 2,
  },
  tablet: {
    breakpoint: { max: 1250, min: 1001 },
    items: 5,
    slidesToSlide: 2,
  },
  smallTablet: {
    breakpoint: { max: 1000, min: 701 },
    items: 3,
    slidesToSlide: 1,
  },
  chonkyPhone: {
    breakpoint: { max: 700, min: 451 },
    items: 2,
    slidesToSlide: 1,
  },
  phone: {
    breakpoint: { max: 450, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};
